<div class="container-fluid" *ngIf="widget$ | async as project">
    <h1>{{ project.data.url }}</h1>
    <ul>
        <li *ngFor="let campaign of campaigns$ | async">
            {{ campaign.title }}
        </li>
    </ul>
</div>
